import s from './Loader.module.css'

const Loader: React.FC = () => {
  return (
    <div className="flex align-center justify-center">
      <div
        className={`rounded-full border-4 border-green-50 w-6 h-6 animate-spin ${s.borderTop}`}
      ></div>
    </div>
  )
}

export default Loader
